<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'ShowMoreLoader',
    props: {
      'self': Number,
      'last': Number,
      'next': [
        Number,
        Boolean,
      ],
      'query': String,
      isModule: Boolean,
    },
    computed: {
      routeMore() {
        const page = this.next || this.self
        const route = { query: { page } }
        if (this.query) {
          route.query.query = this.query
        }
        return route
      },
    },
    methods: {
      loadMore() {
        this.$emit('onLoadMore', this.next || this.self)
      },
    },
  }
</script>
